import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Alert, Box, Chip, CircularProgress, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { adminApproveBroker, adminGetBrokers, adminRejectBroker } from '../../api/adminApi';
import { useAdminAuth } from '../../Context/AdminAuthContext';

export default function AdminBrokers() {
    const { token } = useAdminAuth();
    const [brokers, setBrokers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const load = () => {
        if (!token) return;
        setLoading(true);
        adminGetBrokers(token)
            .then(setBrokers)
            .catch(e => setError(e.message))
            .finally(() => setLoading(false));
    };

    useEffect(load, [token]);

    const approve = async (id: string) => {
        if (!token) return;
        await adminApproveBroker(token, id);
        load();
    };

    const reject = async (id: string) => {
        if (!token) return;
        await adminRejectBroker(token, id);
        load();
    };

    return (
        <Box>
            <Typography variant="h5" fontWeight={700} mb={3}>Brokers</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {loading ? <CircularProgress /> : (
                <Table size="small" sx={{ bgcolor: 'white', borderRadius: 1 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Group</TableCell>
                            <TableCell>Quizzes Passed</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {brokers.map(b => (
                            <TableRow key={b.id} hover>
                                <TableCell>{b.name} {b.surname}</TableCell>
                                <TableCell>{b.email}</TableCell>
                                <TableCell>{b.groupName ?? b.groupSlug}</TableCell>
                                <TableCell>{b.quizzesPassed}</TableCell>
                                <TableCell>
                                    <Chip
                                        label={b.approved ? 'Approved' : 'Pending'}
                                        color={b.approved ? 'success' : 'warning'}
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Tooltip title="Approve">
                                        <IconButton size="small" color="success" onClick={() => approve(b.id)} disabled={b.approved}>
                                            <CheckCircleIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Reject / Revoke">
                                        <IconButton size="small" color="error" onClick={() => reject(b.id)} disabled={!b.approved}>
                                            <CancelIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Box>
    );
}
